'use strict';

import Common from '../../Utils/Common'

/**
 * @classname SearchSort
 * @classdesc 検索結果ソート
 */
export default class SearchSort {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e, controller) {
		console.log('SearchSort.constructor');
		this._$e = $e;
		this._controller = controller;
		this._sort = $e.attr('data-sort');
		this._default = $e.closest('.list').attr('data-default-sort');
		this._$searchBtn = $('.btn--search')
		this._page = 1;
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof SearchSort
	 * @return {undefined}
	 */
	onClick() {
		console.log('SearchSort.onClick');
		if (!this._$e.hasClass('active')) {
			$('.list--search-sort .sort-item').removeClass('active');
			this._$e.addClass('active');
			if(window.innerWidth < 768){
				$('.list--search-sort .sort-item').find('.input-radio-input').prop('checked', false)
				this._$e.find('.input-radio-input').prop('checked', true)
			}
		}

		//パラメータにidが入っていたら、パラメータをそのままにしてソートだけ変更
		let params = Common.getParam();

		if ('id' in params) {
			let url = this._$e.hasClass('current_search')
			? Common.getCurrentURL()
			: window.const.URL.SEARCH;

			let param = '';
			let prefix = '?';
			params['sort'] = this._sort;
			delete params['page'];
			for(const key in params){
				param += `${prefix}${key}=${params[key]}`;
				prefix = '&';
			}
			console.log(`${url}${param}`);
			location.href = `${url}${param}`;
		} else {
			//再検索する
			this._$searchBtn.click()
		}

	};
};